import "../styles/zonestorage.css";
import { readableTextOn } from "./helpers/labelContrast";

// The two big destination squares an operator reads after a scan: left = shelf
// (letter), right = position (number). Shared by Sorter 1 and Pick & Sort so
// both render with identical geometry/typography (owned by
// `.zone-sorter-2-single-result > h1` in zonestorage.css — do NOT set size here).
//
// Colour source differs by caller:
//   • Sorter 1 omits the colours → the fixed `.letter-*` / `.number-*` classes apply.
//   • Pick & Sort passes the configured palette colours → inline background wins.
// Either way the text takes whichever of black/white contrasts more: the
// palette runs from yellow to black, so a fixed white was unreadable on half
// of it. The .letter-*/.number-* rules encode the same choice.
type ZoneSorterLocationBoxesProps = {
    first: string | number;
    second: string | number;
    firstColour?: string | null;
    secondColour?: string | null;
};

const ZoneSorterLocationBoxes = ({ first, second, firstColour, secondColour }: ZoneSorterLocationBoxesProps) => (
    <div className="zone-sorter-2-single-result">
        <h1
            className={firstColour ? undefined : `letter-${first}`}
            style={firstColour ? { backgroundColor: firstColour, color: readableTextOn(firstColour) } : undefined}
        >
            {first}
        </h1>
        <h1
            className={secondColour ? undefined : `number-${second}`}
            style={secondColour ? { backgroundColor: secondColour, color: readableTextOn(secondColour) } : undefined}
        >
            {second}
        </h1>
    </div>
);

export default ZoneSorterLocationBoxes;
